import * as R from 'ramda';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// component charge
import { getChargeGlCodeByCurrency } from '../hocs';
import { accessorialFieldsToPick, accessorialFieldsToPick2 } from '../settings';
import {
  calcSimpleChargeTotal,
  isLineHaulWithPercent,
  isDiscountWithPercent,
  isInvalidChargeRateField,
  isTaxableTotalWithPercent,
  isCustomerRateWithPercent,
  isCustomerLineHaulWithPercent,
  getDefaultChargeUnitFromChargeRateType,
} from '../helpers';
//////////////////////////////////////////////////

// TODO: check if customerTotal the same value as totalCustomersRate remove totalCustomersRate logic:
// const customerRate = G.ifElse(G.isNotNilAndNotEmpty(customerTotal), customerTotal, totalCustomersRate);

// calc charges total
export const calcMainSubtotal = (charges, options) => {
  const { mainChargesTotal, discountChargesTotal } = G.calcAllChargesArrayTotal(charges, options);

  return G.mathRoundNumber(R.subtract(mainChargesTotal, discountChargesTotal));
};

const calcMainTotal = (charge, options) => {
  const { rate, quantity, rateType, rateUnit } = charge;

  const customerLineHaul = G.getPropFromObject('customerLineHaul', options);
  const totalCustomersRate = G.getPropFromObject('totalCustomersRate', options);

  if (isCustomerRateWithPercent(rateType, rateUnit)) {
    if (R.and(G.isNotNilAndNotEmpty(quantity), G.notEquals(totalCustomersRate, quantity))) {
      return G.setPercentage(rate, quantity);
    }

    return G.setPercentage(rate, totalCustomersRate);
  }

  if (isCustomerLineHaulWithPercent(rateType, rateUnit)) {
    if (R.and(G.isNotNilAndNotEmpty(quantity), G.notEquals(customerLineHaul, quantity))) {
      return G.setPercentage(rate, quantity);
    }

    return G.setPercentage(rate, customerLineHaul);
  }

  return calcSimpleChargeTotal(charge);
};

const calcDiscountTotal = (charge, charges) => {
  const { rate, rateType, rateUnit, quantity, holdQuantity } = charge;

  if (R.and(G.isTrue(holdQuantity), isDiscountWithPercent(rateType, rateUnit))) {
    return G.setPercentage(rate, quantity);
  }

  if (isDiscountWithPercent(rateType, rateUnit)) {
    const { mainChargesTotal } = G.calcAllChargesArrayTotal(charges);

    return G.setPercentage(rate, mainChargesTotal);
  }

  return G.ifElse(G.isEmptyString(rate), 0, rate);
};

const calcFuelTotal = (charge, charges, options) => {
  const { rate, quantity, rateType, rateUnit } = charge;

  const customerLineHaul = G.getPropFromObject('customerLineHaul', options);

  if (isLineHaulWithPercent(rateType, rateUnit)) {
    if (R.and(G.isNotNilAndNotEmpty(quantity), G.notEquals(customerLineHaul, quantity))) {
      return G.setPercentage(rate, quantity);
    }

    const mainSubtotal = calcMainSubtotal(charges, options);

    return G.setPercentage(rate, mainSubtotal);
  }

  return calcSimpleChargeTotal(charge);
};

const calcAdditionalTotal = (charge, charges, options) => {
  const { rate, quantity, rateType, rateUnit } = charge;

  const customerLineHaul = G.getPropFromObject('customerLineHaul', options);
  const totalCustomersRate = G.getPropFromObject('totalCustomersRate', options);

  if (isLineHaulWithPercent(rateType, rateUnit)) {
    if (R.and(G.isNotNilAndNotEmpty(quantity), G.notEquals(customerLineHaul, quantity))) {
      return G.setPercentage(rate, quantity);
    }

    const mainSubtotal = calcMainSubtotal(charges, options);

    return G.setPercentage(rate, mainSubtotal);
  }

  if (isTaxableTotalWithPercent(rateType, rateUnit)) {
    return G.setPercentage(rate, quantity);
  }

  if (isCustomerRateWithPercent(rateType, rateUnit)) {
    if (R.and(G.isNotNilAndNotEmpty(quantity), G.notEquals(totalCustomersRate, quantity))) {
      return G.setPercentage(rate, quantity);
    }

    return G.setPercentage(rate, totalCustomersRate);
  }

  if (isCustomerLineHaulWithPercent(rateType, rateUnit)) {
    if (R.and(G.isNotNilAndNotEmpty(quantity), G.notEquals(customerLineHaul, quantity))) {
      return G.setPercentage(rate, quantity);
    }

    return G.setPercentage(rate, customerLineHaul);
  }

  return calcSimpleChargeTotal(charge);
};

const calcChargeTotal = (charge, charges, props) => {
  const rateCurrency = G.getCurrencyFromRate(props);
  const customerLineHaul = R.pathOr(0, ['customerLineHaul'], props);

  const totalCustomersRate = R.pathOr(
    R.pathOr(0, ['totalCustomersRate'], props),
    ['customerTotal'],
    props,
  );

  if (G.isChargeTypeMain(charge)) {
    return calcMainTotal(charge, { customerLineHaul, totalCustomersRate });
  }

  if (G.isChargeTypeDiscount(charge)) {
    return calcDiscountTotal(charge, charges, { rateCurrency });
  }

  if (G.isChargeTypeFuel(charge)) {
    return calcFuelTotal(charge, charges, { rateCurrency, customerLineHaul });
  }

  if (G.isChargeTypeAdditional(charge)) {
    return calcAdditionalTotal(charge, charges, { rateCurrency, customerLineHaul, totalCustomersRate });
  }

  return calcSimpleChargeTotal(charge);
};
// calc charges total

// calc charge quantity
const calcDiscountQty = (options) => {
  const { charge, charges } = options;
  const { rateType, rateUnit } = charge;

  if (isDiscountWithPercent(rateType, rateUnit)) {
    const { mainChargesTotal } = G.calcAllChargesArrayTotal(charges);

    return G.mathRoundNumber(mainChargesTotal);
  }

  return 1;
};

const calcDOQtyFromTime = (rateUnit, serviceDays, chargeQty) => {
  if (R.and(
    G.isNotNilAndNotEmpty(serviceDays),
    R.equals(rateUnit, GC.CHARGE_RATE_UNIT_TYPE_HOUR),
  )) {
    return R.multiply(serviceDays, 24);
  }

  if (G.isNotNilAndNotEmpty(serviceDays)) return serviceDays;

  return chargeQty;
};

const calcDMQtyFromTime = (rateUnit, serviceDays, chargeQty, payedHours) => {
  if (R.and(
    G.isNotNilAndNotEmpty(payedHours),
    R.equals(rateUnit, GC.CHARGE_RATE_UNIT_TYPE_HOUR),
  )) {
    return payedHours;
  }

  return calcDOQtyFromTime(rateUnit, serviceDays, chargeQty);
};

const getTimeRateEventDates = (props) => {
  const { loadType, rateProps = {} } = props;

  const configs = R.mergeDeepRight(rateProps.branchConfigs || {}, rateProps.asyncConfigs || {});
  const explicitEvents = rateProps.events || rateProps.telEvents;

  const loadField = G.isLoadTypeClo(loadType) ? GC.FIELD_CLO : GC.FIELD_TEL;
  const invoiceData = R.path(['asyncInitialData', 'data'], rateProps) || rateProps.initialValues || {};

  const loadSources = [
    rateProps.loadData,
    rateProps[loadField],
    rateProps.load,
    rateProps.details,
    invoiceData[loadField],
    invoiceData,
    rateProps,
  ];

  const load = R.find((item) => item && [item.events, item.stops, item.firstEvent, item.lastEvent]
    .some(G.isNotNilAndNotEmpty), loadSources);

  const eventSource = G.isNotNilAndNotEmpty(explicitEvents) ? { events: explicitEvents } : (load || {});
  const dates = G.getFirstLastEventDateFromLoad(eventSource, loadType, configs);

  return G.isNotNilAndNotEmpty(dates) ? dates : props.eventDates;
};

const calcQtyFromTime = (rateUnit, options) => {
  const { loadType, isInvoice, payedHours, eventDates, serviceDays, chargeQty } = options;

  if (R.and(R.equals(rateUnit, GC.CHARGE_RATE_UNIT_TYPE_HOUR), G.isNotNilAndNotEmpty(chargeQty))) return chargeQty;

  if (G.isNotNilAndNotEmpty(eventDates)) {
    const { lastEventDate, firstEventDate } = eventDates;

    if (G.isNilOrEmpty(firstEventDate) || G.isNilOrEmpty(lastEventDate)) return chargeQty;

    const isHourly = R.equals(rateUnit, GC.CHARGE_RATE_UNIT_TYPE_HOUR);

    const range = isHourly
      ? G.getDateRange(firstEventDate, lastEventDate) / 3600000
      : G.getDateRange(firstEventDate, lastEventDate, 'd');

    return Number.isFinite(range) && range >= (isHourly ? 0 : 1) ? G.mathRoundNumber(range) : chargeQty;
  }

  if (!isInvoice) return chargeQty;

  if (G.isLoadTypeClo(loadType)) {
    return calcDOQtyFromTime(rateUnit, serviceDays, chargeQty);
  }

  if (G.isNilOrEmpty(payedHours)) return chargeQty;

  return calcDMQtyFromTime(rateUnit, serviceDays, chargeQty, payedHours);
};

const calcQtyFromDistance = (rateUnit, distance, distanceUom) => {
  if (R.and(R.equals(rateUnit, GC.UOM_MILE), R.equals(distanceUom, GC.UOM_KILOMETER))) {
    return G.mathRoundNumber(G.fromKmsToMiles(distance));
  } else if (R.and(R.equals(rateUnit, GC.UOM_KILOMETER), R.equals(distanceUom, GC.UOM_MILE))) {
    return G.mathRoundNumber(G.fromMilesToKms(distance));
  }

  return R.or(distance, 0);
};

const applyFreeDistanceToChargeQty = (qty, charge) => {
  const freeDistance = G.getPropFromObject(GC.FIELD_FREE_DISTANCE, charge);

  if (G.isNilOrEmpty(freeDistance)) return qty;

  return G.maxNumber(0, R.subtract(qty, freeDistance));
};

const calcQtyFromWeight = (rateUnit, weight, weightUom) => G.calcWeightFromTo({
  to: rateUnit,
  value: weight,
  from: weightUom,
  toFixedNumber: 2,
});

const calcQtyFromWeight100 = (rateUnit, weight, weightUom) => G.calcWeightFromTo100({
  to: rateUnit,
  value: weight,
  from: weightUom,
  toFixedNumber: 2,
});

const calcQtyFromVolume = (rateUnit, volume) => R.or(volume, 0);

const calcQtyFromLineHaul = (options) => {
  const { props, charge, charges } = options;
  const { rateType, rateUnit } = charge;

  const rateCurrency = G.getCurrencyByPath(props);

  if (isLineHaulWithPercent(rateType, rateUnit)) {
    return calcMainSubtotal(charges, { rateCurrency });
  }

  return 1;
};

const calcTotalTaxableAdditionalCharges = (additionalCharges) => R.compose(
  R.reduce((acc, item) => {
    if (G.isTrue(R.prop(GC.FIELD_CHARGE_NON_TAXABLE, item))) return acc;

    return R.add(acc, G.getTotalFromCharge(item));
  }, 0),
  R.reject((item) => {
    const { rateType, rateUnit } = item;

    return isTaxableTotalWithPercent(rateType, rateUnit);
  }),
)(additionalCharges);

const calcQtyFromTaxableTotal = (options) => {
  const { charge, charges } = options;
  const { rateType, rateUnit } = charge;

  if (isTaxableTotalWithPercent(rateType, rateUnit)) {
    const { additionalCharges } = G.getFilteredByTypeCharges(charges);
    const additionalTaxable = calcTotalTaxableAdditionalCharges(additionalCharges);
    const mainSubtotal = calcMainSubtotal(charges);

    return G.mathRoundNumber(R.add(mainSubtotal, additionalTaxable));
  }

  return 1;
};

const calcChargeQty = (options) => {
  const { props, charge } = options;

  const rateType = G.getRateTypeFromCharge(charge);
  const rateUnit = G.getRateUnitFromCharge(charge);
  const chargeQty = G.getQuantityFromCharge(charge);
  const holdQuantity = G.getHoldQuantityFromCharge(charge);

  if (R.or(G.isTrue(holdQuantity), G.isNilOrEmpty(rateType))) return chargeQty;

  switch (rateType) {
    case GC.CHARGE_RATE_TYPE_STOP:
      const stopsQuantity = R.path(['stopsQuantity'], props);

      if (G.isEmptyString(chargeQty)) return chargeQty;

      if (G.isZero(chargeQty)) return chargeQty;

      if (GC.NUMBER_REGEXP.test(chargeQty)) return chargeQty;

      const minStops = G.getPropFromObject(GC.FIELD_MIN_STOPS, charge);
      const maxStops = G.getPropFromObject(GC.FIELD_MAX_STOPS, charge);

      if (G.isOneNotNilOrNotEmpty([minStops, maxStops])) {
        if (R.gte(minStops, stopsQuantity)) return 0;

        if (R.isNil(maxStops)) return R.subtract(stopsQuantity, minStops);

        if (R.isNil(minStops)) return G.ifElse(R.gt(maxStops, stopsQuantity), stopsQuantity, maxStops);

        const diff1 = R.subtract(stopsQuantity, minStops);
        const diff2 = R.subtract(maxStops, minStops);

        return G.ifElse(R.gt(stopsQuantity, maxStops), diff2, diff1);
      }

      return stopsQuantity;

    case GC.CHARGE_RATE_TYPE_CUSTOMER_RATE:
      const { customerTotal, totalCustomersRate } = props;

      const customerRate = G.ifElse(G.isNotNilAndNotEmpty(customerTotal), customerTotal, totalCustomersRate);

      if (G.isNilOrEmpty(customerRate)) return 1;

      // TODO: remove after customer testing
      // if (R.and(G.isNotNilAndNotEmpty(chargeQty), G.notEquals(customerRate, chargeQty))) {
      //   return chargeQty;
      // }

      return G.mathRoundNumber(customerRate);

    case GC.CHARGE_RATE_TYPE_CUSTOMER_LINE_HAUL:
      const customerLineHaul = R.path(['customerLineHaul'], props);

      if (G.isNilOrEmpty(customerLineHaul)) return 1;

      // TODO: remove after customer testing
      // if (R.and(G.isNotNilAndNotEmpty(chargeQty), G.notEquals(customerLineHaul, chargeQty))) {
      //   return chargeQty;
      // }

      return G.mathRoundNumber(customerLineHaul);

    case GC.CHARGE_RATE_TYPE_DISTANCE:
      const totalTripDistance = R.path([GC.FIELD_TOTAL_TRIP_DISTANCE], props);

      if (G.isNilOrEmpty(totalTripDistance)) return 1;

      return calcQtyFromDistance(
        rateUnit,
        totalTripDistance,
        R.path([GC.FIELD_TOTAL_TRIP_DISTANCE_UOM], props),
      );

    case GC.CHARGE_RATE_TYPE_DEADHEAD_DISTANCE:
      const deadhead = R.path([GC.FIELD_DEADHEAD_DISTANCE], props);

      if (G.isNilOrEmpty(deadhead)) return 1;

      return applyFreeDistanceToChargeQty(
        calcQtyFromDistance(
          rateUnit,
          deadhead,
          R.path([GC.FIELD_DEADHEAD_DISTANCE_UOM], props),
        ),
        charge,
      );

    case GC.CHARGE_RATE_TYPE_WEIGHT:
      const weight = R.path([GC.FIELD_TOTAL_TRIP_WEIGHT], props);

      if (G.isNilOrEmpty(weight)) return 1;

      const weightUom = R.path([GC.FIELD_TOTAL_TRIP_WEIGHT_UOM], props);
      const weight100 = R.or(R.equals(GC.UOM_POUND_100, rateUnit), R.equals(GC.UOM_KILOGRAM_100, rateUnit));

      if (weight100) return calcQtyFromWeight100(rateUnit, weight, weightUom);

      return calcQtyFromWeight(rateUnit, weight, weightUom);

    case GC.CHARGE_RATE_TYPE_VOLUME:
      const volume = R.path([GC.FIELD_TOTAL_TRIP_VOLUME], props);

      if (G.isNilOrEmpty(volume)) return chargeQty;

      return calcQtyFromVolume(
        rateUnit,
        volume,
        R.path([GC.FIELD_TOTAL_TRIP_VOLUME_UOM], props),
      );

    case GC.CHARGE_RATE_TYPE_QUANTITY:
      const quantities = R.path([GC.FIELD_TOTAL_QUANTITIES], props);

      if (G.isNilOrEmpty(quantities)) {
        return R.pathOr(0, [GC.FIELD_CHARGE_QUANTITY], charge);
      }

      return R.pathOr(R.or(chargeQty, 0), [rateUnit], quantities);

    case GC.CHARGE_RATE_TYPE_TIME:
      const { loadType, isInvoice, payedHours, serviceDays } = props;

      const eventDates = getTimeRateEventDates(props);

      return calcQtyFromTime(
        rateUnit,
        { loadType, isInvoice, payedHours, eventDates, serviceDays, chargeQty },
      );

    case GC.CHARGE_RATE_TYPE_DISCOUNT:
      return calcDiscountQty(options);

    case GC.CHARGE_RATE_TYPE_LINE_HAUL:
      return calcQtyFromLineHaul(options);

    case GC.CHARGE_RATE_TYPE_TAXABLE_TOTAL:
      return calcQtyFromTaxableTotal(options);

    default:
      return 1;
  }
};
// calc charge quantity

// set charge quantity and total
const getChargesFromRateProps = (chargesArrayName, rateProps) => R.path(
  ['values', chargesArrayName],
  rateProps,
);

export const setChargeQtyAndTotal = (
  charge,
  props,
  fieldName,
  fieldValue,
) => {
  const { rateProps, chargesArrayName } = props;

  const charges = getChargesFromRateProps(chargesArrayName, rateProps);

  let chargeQty = calcChargeQty({ props, charge, charges });

  if (R.and(G.isNotNil(fieldName), R.equals(fieldName, GC.FIELD_CHARGE_QUANTITY))) {
    chargeQty = fieldValue;
  }

  const chargeWithQty = R.assoc(GC.FIELD_CHARGE_QUANTITY, chargeQty, charge);

  const total = calcChargeTotal(chargeWithQty, charges, props);

  const chargeWithTotal = R.assoc(GC.FIELD_CHARGE_TOTAL, total, chargeWithQty);

  return chargeWithTotal;
};

const setChargeQtyAndTotalOnRecalc = (
  charge,
  charges,
  props,
  options,
) => {
  const omitRecalcChargeId = R.path(['omitRecalcChargeId'], options);

  if (
    R.and(
      G.isString(omitRecalcChargeId),
      R.equals(G.getIdOrGuidFromObject(charge), omitRecalcChargeId),
    )
  ) {
    return charge;
  }

  const chargeQty = calcChargeQty({ props, charge, charges });
  const chargeWithQty = R.assoc(GC.FIELD_CHARGE_QUANTITY, chargeQty, charge);
  const total = calcChargeTotal(chargeWithQty, charges, props);
  const chargeWithTotal = R.assoc(GC.FIELD_CHARGE_TOTAL, total, chargeWithQty);

  return chargeWithTotal;
};
// set charge quantity and total

// charges array input handlers
export const handleChangeCharge = (event, charge, props) => {
  if (isInvalidChargeRateField(event.target)) return;

  const { name, value } = event.target;

  let newCharge = R.assoc(name, value, charge);

  if (R.equals(name, GC.FIELD_CHARGE_RATE_TYPE)) {
    const rateUnit = getDefaultChargeUnitFromChargeRateType(value, props);
    newCharge = {
      ...newCharge,
      [GC.FIELD_CHARGE_QUANTITY]: null,
      [GC.FIELD_CHARGE_RATE_UNIT]: rateUnit,
      [GC.FIELD_CHARGE_HOLD_QUANTITY]: false,
    };
  }

  if (R.and(R.equals(name, GC.FIELD_CHARGE_RATE_UNIT), R.equals(newCharge.rateType, GC.CHARGE_RATE_TYPE_TIME))) {
    newCharge = {
      ...newCharge,
      [GC.FIELD_CHARGE_QUANTITY]: null,
      [GC.FIELD_CHARGE_HOLD_QUANTITY]: false,
    };
  }

  if (R.equals(name, GC.FIELD_CURRENCY)) {
    const { glCodeMappings } = props;

    const glCode = getChargeGlCodeByCurrency(newCharge, null, glCodeMappings);

    newCharge = R.assoc(GC.FIELD_GL_CODE, glCode, newCharge);
  }

  newCharge = setChargeQtyAndTotal(newCharge, props, name, value);

  return newCharge;
};

export const handleChangeChargeSelect = (event, charge, props) => {
  const { value } = event.target;

  const { isInvoice, rateProps, glCodeMappings } = props;

  const { values, accessorials } = rateProps;

  const accessorial = R.pathOr({}, [value], accessorials);
  const originalConfigGuid = G.getPropFromObject(GC.FIELD_ORIGINAL_CONFIG_GUID, accessorial);

  let picked = {
    ...R.pick(accessorialFieldsToPick2, accessorial),
    [GC.FIELD_ORIGINAL_CONFIG_GUID]: originalConfigGuid,
    [GC.FIELD_ACCESSORIAL_CONFIG_GUID]: originalConfigGuid,
    [GC.FIELD_DEDUCTION]: R.propOr(false, GC.FIELD_DEDUCTION, accessorial),
    [GC.FIELD_FREE_DISTANCE]: G.getPropFromObject(GC.FIELD_FREE_DISTANCE, accessorial),
    [GC.FIELD_CHARGE_INTERNAL_EXPENSE]: R.propOr(false, GC.FIELD_CHARGE_INTERNAL_EXPENSE, accessorial),
    [GC.FIELD_SHARED_ASSESSORIAL_GUID]: G.getPropFromObject(GC.FIELD_SHARED_ASSESSORIAL_GUID, accessorial),
  };

  if (G.isTrue(isInvoice)) {
    const currency = G.getCurrencyFromObject2(values);
    const mappings = R.pathOr(glCodeMappings, [currency], glCodeMappings);

    const glCode = R.pathOr('', [GC.INVOICE_MAPPING_TYPE_ASSESSORIALS, originalConfigGuid], mappings);
    picked = R.assoc(GC.FIELD_GL_CODE, glCode, picked);
  }

  if (G.isNotNilAndNotEmpty(picked)) {
    const merged = R.mergeDeepRight(charge, picked);

    if (R.and(
      R.equals(merged.rateType, GC.CHARGE_RATE_TYPE_TIME),
      R.equals(merged.rateUnit, GC.CHARGE_RATE_UNIT_TYPE_HOUR),
    )) {
      merged.quantity = R.propOr(null, GC.FIELD_CHARGE_QUANTITY, accessorial);
    }

    const newCharge = setChargeQtyAndTotal(merged, props);

    return newCharge;
  }

  return charge;
};
// charges array input handlers

// recalculate charges
export const recalculateAllCharges = (charges, props, options) => {
  if (G.isNilOrEmpty(charges)) return charges;

  const { mainCharges, fuelCharges, discountCharges, additionalCharges } = G.getFilteredByTypeCharges(charges);

  const newMainCharges = R.map(
    (charge) => setChargeQtyAndTotalOnRecalc(charge, charges, props, options),
    mainCharges,
  );

  const newDiscountCharges = R.map(
    (charge) => setChargeQtyAndTotalOnRecalc(charge, newMainCharges, props, options),
    discountCharges,
  );

  const newMainAndDiscountCharges = R.concat(newMainCharges, newDiscountCharges);

  const newFuelCharges = R.map(
    (charge) => setChargeQtyAndTotalOnRecalc(charge, newMainAndDiscountCharges, props, options),
    fuelCharges,
  );

  const newMainAndDiscountFuelCharges = R.concat(newMainAndDiscountCharges, newFuelCharges);

  const newMainDiscountFuelWithOldAdditionalCharges = R.concat(newMainAndDiscountFuelCharges, additionalCharges);

  const newAdditionalCharges = R.map(
    (charge) => setChargeQtyAndTotalOnRecalc(
      charge,
      newMainDiscountFuelWithOldAdditionalCharges,
      props,
      options,
    ),
    additionalCharges,
  );

  return R.reduce(R.concat, newMainCharges, [newDiscountCharges, newFuelCharges, newAdditionalCharges]);
};
// recalculate charges
